import {UUIDEmpty, Values} from "@wix/devzai-utils-common";
import {WixAppRuntimeEnvironment} from "@wix/devzai-common-wix";

export const DoppeAppVariant = {
    Default: UUIDEmpty,
    HadreiHaredim: 'aa291900-dec7-48c9-9208-5b2f7f8f9d4c',
    WixLite: '60e8a9c1-46f6-4835-b68f-7d3901ec10c7'
} as const;

export type DoppeAppVariant = Values<typeof DoppeAppVariant>;

export function doppeAppVariantIsNotDefault (doppeAppVariant: DoppeAppVariant) {
    return doppeAppVariant !== DoppeAppVariant.Default;
}

export function doppeAppVariantGetDisplayNameForBiEvents (doppeAppVariant: DoppeAppVariant) {
    switch (doppeAppVariant) {
        case DoppeAppVariant.Default:
            return 'Default';
        case DoppeAppVariant.HadreiHaredim:
            return 'HadreiHaredim';
        case DoppeAppVariant.WixLite:
            return 'WixLite';
        default:
            return 'Unknown';
    }
}

export function doppeAppVariantIsLinkInBioOnSubdomain (
    appVariant: DoppeAppVariant,
    options: {
        appRuntimeEnvironment: WixAppRuntimeEnvironment
    }
) {
    const {
        appRuntimeEnvironment
    } = options;

    switch (appVariant) {
        case DoppeAppVariant.Default: {
            return false;
        }
        case DoppeAppVariant.HadreiHaredim: {
            return false;
        }
        case DoppeAppVariant.WixLite: {
            switch (appRuntimeEnvironment) {
                case WixAppRuntimeEnvironment.Local: return true;
                case WixAppRuntimeEnvironment.Staging: return true;
                case WixAppRuntimeEnvironment.Production: return true;
            }
        }
    }
}